import { z } from "zod";

const translationPath = "page.dashboardGenerateConfig.errors.";

const positiveInt = (message: string) =>
  z.coerce.number({ invalid_type_error: message }).int(message).min(1, message);

export const generateConfigSchema = z.object({
  id: z.string().optional(),
  maxBatchSize: positiveInt(translationPath + "max_batch_size"),
  maxBatchNumbers: positiveInt(translationPath + "max_batch_numbers"),
  maxRetries: positiveInt(translationPath + "max_retries"),
  maxPendingBatchTransactions: positiveInt(
    translationPath + "max_pending_batch_transactions",
  ),
  retentionDaysReduced: positiveInt(translationPath + "retention_days_reduced"),
  retentionDaysFailed: positiveInt(translationPath + "retention_days_failed"),
  alertEmails: z
    .string()
    .max(1000, translationPath + "alert_emails")
    .nullish()
    .refine(
      (val) =>
        !val?.trim() ||
        val
          .split(/[,;]/)
          .map((email) => email.trim())
          .filter(Boolean)
          .every((email) => z.string().email().safeParse(email).success),
      { message: translationPath + "alert_emails" },
    ),
});

export type TGenerateConfigForm = z.infer<typeof generateConfigSchema>;
